import React from 'react';
import Home from '../components/Home';

function HomePage() {
    return <Home />;
}

export default HomePage;
